

















































































import Vue, { PropOptions } from 'vue';
import BillingService, { BillingAccount, PaymentMethod } from '~/services/BillingService';
import { getPaymentMethodBrandLogo, getPaymentMethodBrandString } from '../util';
import Button from '~/components/builders/Base/Button.vue';
import { PaymentMethodItem } from '../types';

export default Vue.extend({
    name: 'Payment',
    components: {
        Button,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
    },
    data() {
        return {
            service: new BillingService(),
            loading: false,
            error: null as string | null,

            paymentMethods: [] as PaymentMethod[],
            overrideDefaultPaymentMethod: null as string | null,
            removedPaymentMethods: [] as string[],
        };
    },
    computed: {
        paymentMethodItems(): PaymentMethodItem[] {
            const defaultMethodId =
                this.overrideDefaultPaymentMethod !== null
                    ? this.overrideDefaultPaymentMethod
                    : !!this.billingAccount.defaultPaymentMethod
                    ? this.billingAccount.defaultPaymentMethod.id
                    : null;

            return this.paymentMethods.reduce<PaymentMethodItem[]>(
                (acc, pm) =>
                    !pm.card || this.removedPaymentMethods.includes(pm.id)
                        ? acc
                        : [
                              ...acc,
                              {
                                  id: pm.id,
                                  logo: getPaymentMethodBrandLogo(pm.card.brand),
                                  brand: getPaymentMethodBrandString(pm.card.brand),
                                  last4: pm.card.last4,
                                  name: pm.billingDetails ? pm.billingDetails.name : 'Unknown',
                                  expiration: pm.card
                                      ? `${pm.card.expMonth}/${pm.card.expYear.toString().slice(2)}`
                                      : 'Unknown',
                                  isDefault: pm.id === defaultMethodId,
                              },
                          ],
                []
            );
        },
    },
    methods: {
        getPaymentMethods() {
            this.loading = true;
            this.service
                .getPaymentMethods(this.billingAccount.id)
                .then(pms => (this.paymentMethods = pms))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },

        handleError(err: any) {
            console.error(err);
            this.error = this.$t('errors.tryAgain').toString();
            return null;
        },

        async handleAdd() {
            const data = await BillingService.createStripeCheckoutSession({
                mode: 'setup',
            }).catch(this.handleError);

            if (!!data) {
                this.error = null;
                BillingService.redirectToStripeSession(data);
            }
        },
        handleSetDefault(pm: PaymentMethodItem) {
            this.loading = true;
            this.service
                .updateDefaultPaymentMethod(this.billingAccount.id, pm.id)
                .then(ok => (this.overrideDefaultPaymentMethod = ok ? pm.id : null))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },
        handleRemove(pm: PaymentMethodItem) {
            const proceed = window.confirm(
                this.$t('plansAndBilling.paymentMethod.promptRemove', {
                    cardType: pm.brand,
                    lastDigits: pm.last4,
                }).toString()
            );
            if (!proceed) return;

            this.loading = true;
            this.service
                .removePaymentMethod(this.billingAccount.id, pm.id)
                .then(() => (this.removedPaymentMethods = [...this.removedPaymentMethods, pm.id]))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.getPaymentMethods();
    },
});
